import { axiosEduServer } from "../utils/configAxios";

export const registrarAsistencia = (body) => {
  return axiosEduServer.post("/asistencia", body)
    .then((res) => res.data)
    .catch((err) => { throw err; });
};

export const actualizarAsistencia = (idAsistencia, body) => {
  return axiosEduServer.put(`/asistencia/${idAsistencia}`, body)
    .then((res) => res.data)
    .catch((err) => { throw err; });
};

export const eliminarAsistencia = (id) => {
  return axiosEduServer.delete(`/asistencia/${id}`)
    .then(({ data }) => data)
    .catch((err) => { console.log(err); throw err });
};

export const getOneAsistencia = (idAsistencia) => {
  return axiosEduServer.get(`/asistencia/${idAsistencia}`)
    .then(({ data }) => data)
    .catch((err) => {
      console.error("Error en getOneAsistencia:", err);
      throw err;
    });
};

export const getAllAsistencias = () => {
  return axiosEduServer.get("/asistencia")
    .then(({ data }) => data)
    .catch((err) => {
      console.error("Error en getAllAsistencias:", err);
      throw err;
    });
};

export const getAllAsistenciasByGrupo = async (idGrupo, fecha) => {
  try {
    const todas = await getAllAsistencias(); // GET /asistencia
    return todas.filter((a) => {
      if (!a.fechaAsistencia) return false;
      const soloFecha = a.fechaAsistencia.split("T")[0];
      return (soloFecha === fecha);
    });
  } catch (err) {
    console.error("Error en getAllAsistenciasByGrupo:", err);
    throw err;
  }
};
export const getAsistenciasByDocenteIdiomaGrupoEstado = (
  idDocente, idIdioma, idGrupo, estado
) => {
  return axiosEduServer.get(`/asistencia/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/${estado}`).then((res) => res.data).catch((err) => { throw err; });};
 
export const getAllRegistrosByIdDocenteIdIdiomaIdGrupoEstado = (
  idDocente, idIdioma, idGrupo, estado
) => {
  return axiosEduServer.get(`/registro/iddocente/${idDocente}/ididioma/${idIdioma}/idgrupo/${idGrupo}/estado/${estado}`).then((res) => res.data).catch((err) => { throw err; });};

export const getAllTipoAsistencia = () => {
  return axiosEduServer.get("/tipoasistencia").then(({ data }) => data).catch((err) => { throw err; });};